import { render, staticRenderFns } from "./stream_scheme.vue?vue&type=template&id=3bef0be4"
import script from "./stream_scheme.vue?vue&type=script&lang=js"
export * from "./stream_scheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports